import { OrganizationSurveyState } from '../../models/state';
import { actionTypes } from '../actions/organizationSurvey';

const initialState: OrganizationSurveyState = {
  organizationSurveys: [],
  dropdownValues: {},
  organizationSurveyCount: 0,
};
const organizationSurveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ORGANIZATION_SURVEYS_SUCCESS: {
      const { country, organization, progress, year, survey, region, surveySeriesName } = action.payload.dropdownValues;
      return {
        ...state,
        organizationSurveys: action.payload.organizationSurveys,
        organizationSurveyCount: action.payload.count,
        dropdownValues: {
          country,
          organization,
          progress,
          'creation year': year,
          survey,
          region,
          'survey series name': surveySeriesName,
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default organizationSurveyReducer;
